import {Link, useNavigate} from 'react-router-dom'
import {Button, Space} from 'antd'
import {LeftOutlined} from '@ant-design/icons'
import React from 'react'

export default function FixedHeader({onClose = null}) {
  const navigate = useNavigate()

  if(onClose === null)
    onClose = () => {navigate('/')}

  return (
    <>
      <Space size={[18, 20]} direction="vertical" className="pl-2 pb-2 fixed-header--text-page">

          <Button
            type="text"
            className="btn-cancel"
            icon={<LeftOutlined/>}
            onClick={onClose}
          >Zpět</Button>

      </Space>
      <div className="fixed-header-spacer"></div>
    </>
  )
}